import React, { useState } from 'react';
import { Switch } from '@blueprintjs/core';

import ZoneSection from './ZoneSection';

import { byZone } from '../helpers/colors';
import useZoneSections from '../hooks/useZoneSections';
import useEnhancedZones from '../hooks/useEnhancedZones';

import styles from './ZoneDesc.module.scss';

const switchStyle = { display: 'flex', justifyContent: 'flex-end' };

const ZoneDesc = ({ zone: uniqZone, zones: rawZones }) => {
  const [hideEmpty, setHideEmpty] = useState(false);

  const zones = useEnhancedZones(
    (rawZones || [uniqZone]).map((zone, index) => ({ ...zone, color: byZone[index] })),
  );

  const sections = useZoneSections();

  return (
    <div className={styles.main}>

      <div
        className={styles.emptySwitch}
        style={switchStyle}
      >
        <Switch
          checked={hideEmpty}
          label="Cacher les champs vides"
          onChange={() => setHideEmpty(prevValue => !prevValue)}
        />
      </div>

      {sections.map(({ data }) => (
        <ZoneSection
          key={data.Key}
          settings={data}
          zones={zones}
          hideNa={hideEmpty}
        />
      ))}
    </div>
  );
};

export default ZoneDesc;
